module.exports = __webpack_public_path__ + "img/Producer1.bb7db50e.png";